module.exports = "<div class=\"stackedcolumn\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/charts/stackedcolumn.html
// module id = 631
// module chunks = 0